import { getSuggestedAddressError } from 'redux/modules/address-suggestion/selectors';

export const addressSuggestionRequestError = state => {
  const { error = {} } = getSuggestedAddressError(state) || {};
  const { response = {} } = error;
  const { body = '' } = response;
  return body;
};
